<template>
  <div class="text-left">
    <template v-if="canReadyForOrder">
      <v-checkbox v-model="readyForOrder" @click="saveAndSetReadyForOrder($event)" class="mt-4 mb-0 custom-margin-checkbox"
                  label="Ready for order?"></v-checkbox>
    </template>
    <template v-else>
      <template v-if="showGetPriceButton">
        <v-form
            ref="furtherInfoSecondForm"
            v-model="secondFormValid"
            lazy-validation>
          <v-row class="justify-space-between mb-2 mt-6">
            <v-col md="4" sm="12">
              <v-select
                  :label="$t('chargeLevelLabel')"
                  return-object
                  v-model="extraCharge"
                  :items="prices"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  :menu-props="{ offsetY: true }"
                  :no-data-text="$t('noDataAvailable')"
                  @change="setChargeId(extraCharge.id)"
              >
                <template v-slot:append-outer>
                  <v-btn
                      color="red"
                      class="mt-n1"
                      dark
                      x-small
                      outlined
                      fab
                      @click="removePrice()"
                      v-if="extraCharge !== null"
                  >
                    <v-icon dark>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </template>
              </v-select>
            </v-col>
            <v-col md="5" sm="12" class="d-flex" v-if="canAddCustomer">
              <v-autocomplete
                  v-model="customer"
                  dense
                  item-text="name1"
                  item-value="companyNumber"
                  :items="getCustomers"
                  :label="$t('customerLabel')"
                  outlined
                  return-object
                  :rules="customerRules"
                  required
                  :menu-props="{ offsetY: true }"
                  :no-data-text="$t('noDataAvailable')"
                  :filter="customFilter"
              >
                <template slot="selection" slot-scope="data">
                  <div class="v-select__selection v-select__selection--comma">{{ data.item.name1 }} - {{ data.item.companyNumber }}</div>
                </template>
                <template slot="item" slot-scope="data">
                  <div>{{ data.item.name1 }} - {{ data.item.companyNumber }}</div>
                </template>
                <template v-slot:append-outer>
                  <v-btn
                      class="mt-n1"
                      x-small
                      outlined
                      fab
                      @click="showCustomerDialog = true"
                  >
                    <v-icon dark>
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>

        <v-btn text color="primary" :disabled="!isValid || !secondFormValid" class="mt-n2" @click="saveAndGetPrice()" :loading="priceLoading">
          <v-icon left>mdi-arrow-down</v-icon>
          <span class="text-uppercase font-weight-bold">{{$t('getPriceLabel')}}</span>
        </v-btn>
      </template>
      <template v-if="showTotalPrice">
        <v-divider class="mt-4 mb-4"></v-divider>
<!--          <v-row>-->
<!--              <v-col v-for="price in priceListDetails">-->
<!--                  <div class="grey&#45;&#45;text">{{$t(price.label)}}</div>-->
<!--                  <p>{{ price.netValue.toString().replace('.', ',') }} €</p>-->
<!--              </v-col>-->
<!--          </v-row>-->
          <v-row>
              <v-col>
                  <v-data-table
                      :hide-default-footer="true"
                      :hide-header="true"
                      :headers="priceListHeaders"
                      :items="priceListDetails"
                      disable-pagination
                      :loading-text="$t('tableLoadingLabel')">
                      <template v-slot:no-data>
                          {{$t('noDataAvailable')}}
                      </template>
                      <template v-slot:no-results>
                          {{$t('noDataAvailable')}}
                      </template>
                      <template #item.description="{item}">
                          <span v-if="item.label == 'chargeAmountLabel' || item.label == 'myAccessoriesLabel'">{{$t(item.label)}}</span>
                          <span v-else :class="
                          {
                              'font-weight-bold': item.articleNo === 'KTU' || item.articleNo === 'LLT100089' || item.articleNo === 'KTU_FRACHT' || item.articleNo === 'KTU_MAT' || item.articleNo === 'CUST_ARTIKEL'
                          }">{{item.description}}</span>
                      </template>
                      <template #item.netValue="{item}">
                          {{parseFloat(item.netValue).toFixed(2).toString().replace('.', ',')}} &euro;
                      </template>
                      <template v-slot:body.append>
                          <tr>
                              <th class="text-right" colspan="2" style="font-size: .875rem">{{$t('totalPriceLabel')}}: {{parseToGermanFloat(calculatedPrice)}} &euro;</th>
                          </tr>
                      </template>
                  </v-data-table>
              </v-col>
          </v-row>
        <v-row>
<!--          <v-col>-->
<!--            <div class="grey&#45;&#45;text">{{$t('totalPriceLabel')}}</div>-->
<!--            <p>{{ parseToGermanFloat(price) }} €</p>-->
<!--          </v-col>-->
          <v-col>
            <div v-if="canEditPrice" class="d-flex align-center" style="min-width:10rem; max-width: 13rem">
              <v-text-field hide-details class="primary--text font-weight-bold mr-2" :label="$t('newPriceLabel')" v-model="actualPrice" outlined dense suffix="€"
                            @input="priceChangeInPercentage()">
              </v-text-field>
              <div v-if="changed" class="ml-3 percentage-calculation" @click="priceIncreased = !priceIncreased">
                <div>
                  <div :class="[ parseFloatFromGermanFloat(this.actualPrice) >= parseFloatFromGermanFloat(this.initialPrice) ? 'green--text' : 'red--text']"><span
                          v-if="this.pricePercentage>0">+</span><span>{{this.pricePercentage ? this.pricePercentage : 0}}%</span></div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="text-right" v-if="canGetPriceAndOrderOffer">
            <div class="my-2">
              <v-btn depressed class="green white--text" @click="saveAndMakeOrder()" :disabled="!isValid || !secondFormValid" :loading="orderLoading">{{$t('orderNowLabel')}}</v-btn>
            </div>
            <div class="my-2">
              <v-btn depressed class="orange white--text" @click="showOfferDialog = true" :disabled="!isValid || !secondFormValid">{{$t('addOfferLabel')}}</v-btn>
            </div>
          </v-col>
<!--            <v-col class="text-right" v-if="canGetPriceAndOrderOffer">-->
<!--          </v-col>-->
        </v-row>
      </template>
    </template>
    <v-dialog
            :close-delay="3000"
            v-model="snackbar.show"
            max-width="360"
            overlay-opacity="0.3"
    >
      <v-card>
        <div class="pa-4 pb-0">
          <div class="subtitle-1 text-center" v-text="snackbar.message"></div>
        </div>
        <v-card-actions>
          <v-btn
                  small
                  class="mx-auto"
                  color="primary"
                  @click="snackbar.show = false"
          >
            {{$t('closeLabel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        :close-delay="3000"
        v-model="showOfferDialog"
        max-width="360"
        overlay-opacity="0.5"
        persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{$t('addOfferLabel')}}</span>
        </v-card-title>
        <v-card-text>
            <v-form ref="offerForm" v-model="offerFormValid" lazy-validation>
              <v-row>
                <v-col>
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field class="mr-4" outlined clearable @click:clear="clearDate" dense
                                    v-model="selectedDate" :label="$t('validityDateLabel')" readonly v-bind="attrs" v-on="on"
                                    :rules="[v => !!v || $t('requiredValueLabel')]">
                      </v-text-field>
                    </template>
                    <v-date-picker :min="new Date().toISOString()" :locale="$i18n.locale" color="primary" v-model="selectedDate" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="red darken-1"
              text
              @click="closeOfferDialogEventHandler"
          >
            {{$t('closeLabel')}}
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="saveAndSetOffer"
              :loading="offerLoading"
          >
            {{$t('saveDataLabel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        :close-delay="3000"
        v-model="showCustomerDialog"
        max-width="600"
        overlay-opacity="0.5"
        persistent>
      <v-tabs>
        <v-tab>{{$t('selectCustomerLabel')}}</v-tab>
        <v-tab>{{$t('addCustomerLabel')}}</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{$t('selectCustomerLabel')}}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="selectCustomerForm" v-model="selectCustomerFormValid" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        @keyup="selectCustomerHasError = false"
                        @keydown.enter.prevent
                        v-model="customerNo"
                        :rules="[v => !!v || $t('requiredValueLabel')]"
                        :error-messages="selectCustomerHasError ? [$t('customerNotExistsMessage')] : []"
                        dense
                        :label="$t('customerNoLabel')"
                        outlined></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="closeSelectCustomerDialogEventHandler"
              >
                {{$t('closeLabel')}}
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="selectCustomer"
                  :loading="selectCustomerLoading"
              >
                {{$t('selectLabel')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{$t('addCustomerLabel')}}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="addCustomerForm" v-model="customerFormValid" lazy-validation>
                <v-row>
                  <v-col md="6" sm="12">
                    <v-checkbox v-model="customerFormProperties.isCompany" dense hide-details :label="$t('companyLabel')"></v-checkbox>
                  </v-col>
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.title" dense hide-details class="m2-8" :label="$t('titleLabel')" outlined></v-text-field>
                  </v-col>
                  <!--            </v-row>-->
                  <!--            <v-row>-->
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.name" dense hide-details class="m2-8" :label="customerFormProperties.isCompany ? $t('nameLabel') : $t('firstNameLabel')" outlined></v-text-field>
                  </v-col>
                  <transition name="slide-fade">
                    <v-col md="6" sm="12" v-if="!customerFormProperties.isCompany">
                      <v-text-field v-model="customerFormProperties.lastName" dense hide-details class="m2-8" :label="$t('lastNameLabel')" outlined></v-text-field>
                    </v-col>
                  </transition>
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.city" dense hide-details class="m2-8" :label="$t('cityLabel')" outlined></v-text-field>
                  </v-col>
                  <!--            </v-row>-->
                  <!--            <v-row>-->
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.postCode" dense hide-details class="m2-8" :label="$t('postCodeLabel')" outlined></v-text-field>
                  </v-col>
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.street" dense hide-details class="m2-8" :label="$t('streetLabel')" outlined></v-text-field>
                  </v-col>
                  <!--            </v-row>-->
                  <!--            <v-row>-->
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.houseNo" dense hide-details class="m2-8" :label="$t('houseNoLabel')" outlined></v-text-field>
                  </v-col>
                  <v-col md="6" sm="12">
                    <v-select
                        v-model="customerFormProperties.country"
                        dense
                        item-text="Name"
                        class=""
                        item-value="Value"
                        :items="lands"
                        :label="$t('landLabel')"
                        outlined
                        required
                        :no-data-text="$t('noDataAvailable')"
                        hide-details
                        :menu-props="{ offsetY: true }"
                    >
                    </v-select>
                  </v-col>
                  <!--            </v-row>-->
                  <!--            <v-row>-->
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.tellNumbr" dense hide-details class="m2-8" :label="$t('tellNumbrLabel')" outlined></v-text-field>
                  </v-col>
                  <v-col md="6" sm="12">
                    <v-text-field v-model="customerFormProperties.eMail" dense hide-details class="m2-8" :label="$t('emailLabel')" outlined></v-text-field>
                  </v-col>
                  <!--            </v-row>-->
                  <!--            <v-row>-->
                  <v-col md="6" sm="12">
                    <v-select
                        v-model="customerFormProperties.language"
                        dense
                        item-text="name"
                        class=""
                        item-value="isO639"
                        :items="languages"
                        :label="$t('languageLabel')"
                        outlined
                        required
                        :no-data-text="$t('noDataAvailable')"
                        hide-details
                        :menu-props="{ offsetY: true }"
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="closeCustomerDialogEventHandler"
              >
                {{$t('closeLabel')}}
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="saveCustomer"
                  :loading="addCustomerLoading"
              >
                {{$t('saveDataLabel')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs>

    </v-dialog>
  </div>
</template>
<script>
  import productConfigurationService from "../../../services/Configurator/ProductConfigurationService";
  import {MainNavigationFilter} from '../../../configurator/MainNavigation';
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import StatusTypes from "../../../configurator/StatusTypes";
  import UserTypes from "../../../auth/userTypes";
  import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService'
import functionsModule from '@/store/configurator/functionsModule';
  export default {
    name: "GetProductPrice",
    data() {
      return {
        extraCharge: null,
        prices: [],
        changed: false,
        pricePercentage: null,
        initialPrice: null,
        actualPrice: null,
        canGetPriceAndOrderOffer: false,
        canReadyForOrder: false,
        readyForOrder: false,
        priceLoading: false,
        orderLoading: false,
        offerLoading: false,
        showGetPriceButton: true,
        showTotalPrice: false,
        parseToGermanFloat: parseToGermanFloat,
        parseFloatFromGermanFloat: parseFloatFromGermanFloat,
        price: 0,
        calculatedPrice: 0,
        windowMainNavId: 9,
        snackbar: {
          show: false,
          message: "",
        },
        canEditPrice: false,
        showOfferDialog: false,
        menu: false,
        selectedDate: "",
        offerFormValid: true,
        priceListDetails: [],
        priceListHeaders: [
          {
            text: 'Beschreibung',
            value: 'description'
          },
          {
            text: 'Netto Wert',
            value: 'netValue',
            align: 'right',
          },
        ],
        secondFormValid: true,
        customers: [],
        customerRules:[
          v => !!v && v.length !== 0 || this.$t('requiredValueLabel')
        ],
        customerFormValid: true,
        showCustomerDialog: false,
        addCustomerLoading: false,
        canAddCustomer: false,
        customerFormProperties: {
          isCompany: false,
          title: '',
          name: '',
          lastName: '',
          city: '',
          postCode: '',
          street: '',
          houseNo: '',
          country: '',
          tellNumbr: '',
          eMail: '',
          language: ''
        },
        languages: [],
        selectCustomerFormValid: true,
        customerNo: '',
        selectCustomerLoading: false,
        selectCustomerHasError: false
      };
    },
    props:{
      form : Object,
      isValid: Boolean,
      lands: Array
    },
    computed: {
      ...mapGetters("configuratorModule", ["getCurrentDoorConfiguration", "getMainNav", "getChargeId", "getProductId"]),
      ...mapGetters("furtherInformationModule", ["getIncoterm", "getDeliveryAddress", "getPaymentTerm", "getPurchNoC", 'getAccessories', 'getCustomer', 'getCustomers']),
      dateText(){
        return
      },
      allCustomers(){
        return this.$store.state.furtherInformationModule.customers
      },
      customer: {
        //getter
        get: function () {
          return this.getCustomer
        },
        //setter
        set: function (newValue) {
          this.$store.dispatch('furtherInformationModule/setCustomer', newValue)
        }
      }
    },

    watch: {
    // whenever question changes, this function will run
    actualPrice: function (newPrice, oldPrice) {
      if(oldPrice !== null)
        this.$store.dispatch('setConfigurationStatus',true)

      this.$store.dispatch('setCurrentProductChangedPrice', parseFloatFromGermanFloat(newPrice));

      //change precentage
      this.priceChangeInPercentage();
      },
      initialPrice: function(){
        //change precentage
        this.priceChangeInPercentage();
      }
    },

    methods: {
      ...mapActions("configuratorModule", ["setProductId", "setMainNavigationItems", "setChargeId"]),
      ...mapActions("furtherInformationModule", ["setCustomers", 'addCustomer']),
      getAllCustomers(){
        if (this.getCustomers.length === 0){
          this.axios.get('api/company/getall')
              .then(res => {
                this.setCustomers(res.data)

                const customer = this.getCustomer
                if (customer !== ''){
                  const findCustomer = this.getCustomers.find(f => f.companyNumber === customer.companyNumber)
                  if (findCustomer === undefined){
                    this.addCustomer(this.getCustomer)
                  }
                }
              })
        }
      },
      saveAndGetPrice() {
        let mainNav = new MainNavigationFilter(this.getMainNav);

        var obj = {
          incoterm: this.getIncoterm,
          paymentTerm: this.getPaymentTerm,
          purchNoC: this.getPurchNoC
        }
        let mainNavItems = mainNav.UpdateMainNavigation(obj, this.windowMainNavId + 1);
        // this.$store.dispatch('setMainNavigationItems', mainNavItem
        this.setMainNavigationItems(mainNavItems);

        this.$store.dispatch('setConfigurationStatus',true)

        const valid = this.form.furtherInfoForm.validate();
        const validSecondForm = this.$refs.furtherInfoSecondForm.validate();

        if(valid && validSecondForm){
          this.priceLoading = true;
          productConfigurationService
            .saveCurrentProductConfigurator(this.getCurrentDoorConfiguration)
            .then((response) => {
              if (response.data !== "") {
                this.setProductId(response.data.id);
                this.$store.dispatch("storeCurrentProduct", response.data);
                this.getPrice(response.data.id);
              }
            });
        }        
      },
      canEditPriceRequest() {
        this.axios.get("/api/user/me")
        .then((response) => {
          this.canEditPrice = response.data.canEditPrice
        })
        .catch(error => {console.log(error)})
      },
      getPrice(productId) {
        this.axios
          .get("/api/sap/getProductPrice", {
            params: {
              productId: productId,
            },
          })
          .then((response) => {
            let result = response.data[0];
            if(result.errorStatus === true) {
              this.snackbar.message = result.errorMessage;
              this.snackbar.show = true;
            }

            let calculatedTotalPrice = (result.totalAmount + result.extraChargeAmount).toFixed(2)
              if (this.getAccessories.length > 0){
                  calculatedTotalPrice = (parseFloat(calculatedTotalPrice) + parseFloat(this.calculatePrice(this.getAccessories))).toFixed(2)
              }
            this.price = result.totalAmount;
              this.calculatedPrice = parseToGermanFloat(calculatedTotalPrice);
            this.actualPrice = parseToGermanFloat(this.price);
            this.initialPrice = this.price;
            this.priceListDetails = result.order ? result.order : []

            var currentProduct = this.$store.state.currentProduct;
            currentProduct.price = result.totalAmount;
            currentProduct.changedPrice = parseFloatFromGermanFloat(this.actualPrice);
            // currentProduct.changedPrice = calculatedTotalPrice;
            currentProduct.priceDetails = this.priceListDetails ? JSON.stringify(this.priceListDetails) : [];

              if (this.getAccessories.length > 0 && this.priceListDetails){
                  const accessoriesPrice = this.calculatePrice(this.getAccessories)
                  this.priceListDetails.push({description: '', articleNo: 'CUST_ARTIKEL', label: "myAccessoriesLabel", netValue: accessoriesPrice, currency: 'EUR'})
              }

            this.$store.dispatch("storeCurrentProduct", currentProduct);
            // this.showGetPriceButton = false;
            this.showTotalPrice = !result.errorStatus;
            this.priceLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
            this.priceLoading = false;
          });
      },
      saveAndMakeOrder() {
        const valid = this.form.furtherInfoForm.validate();
        if(!valid)
          return;

        this.orderLoading = true;
        productConfigurationService
          .saveCurrentProductConfigurator(this.getCurrentDoorConfiguration)
          .then((response) => {
            if (response.data !== "") {
              this.setProductId(response.data.id);
              this.$store.dispatch("storeCurrentProduct", response.data);
              this.makeOrder(response.data.id);
            }
          });
      },

      makeOrder(productId) {
        var data = {
          ProductId: productId,
        };
        this.axios
          .post("/api/sap/makeOrder", data)
          .then((response) => {
            var data = JSON.parse(response.data);
            this.orderLoading = false;

            var hostname = window.location.hostname;
            window.location.href = "/dashboard/orders";
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },
      saveAndSetReadyForOrder(e) {
        const valid = this.form.furtherInfoForm.validate();

        if (!valid){
          e.preventDefault()
          e.stopPropagation()
          this.readyForOrder = !this.readyForOrder
          return
        }

        NProgress.start()

        productConfigurationService
            .saveCurrentProductConfigurator(this.getCurrentDoorConfiguration)
            .then((response) => {
              if (response.data !== "") {
                this.setProductId(response.data.id);
                this.$store.dispatch("storeCurrentProduct", response.data);
                this.setReadyForOrder(response.data.id);
                NProgress.done()
              }
            });
      },
      saveAndSetOffer() {
        const valid = this.$refs.offerForm.validate();
        if(!valid)
          return;

        this.offerLoading = true

        productConfigurationService
          .saveCurrentProductConfigurator(this.getCurrentDoorConfiguration)
          .then((response) => {
            if (response.data !== "") {
              this.setProductId(response.data.id);
              this.$store.dispatch("storeCurrentProduct", response.data);
              this.setOffer(response.data.id);
            }
          });
      },
      setReadyForOrder(productId) {
        const data = {
          id: productId,
          value: this.readyForOrder
        };

        this.axios.post("/api/productconfiguration/setReadyForOrder", data)
            .then((response) => {
              this.$store.dispatch("storeCurrentProduct", response.data);
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            })
            .finally(() => {
              this.offerLoading = false
            });
      },
      setOffer(productId) {
        const data = {
          id: productId,
          validityDate: this.selectedDate
        };

        this.axios.post("/api/productconfiguration/setOffer", data)
            .then((response) => {
            this.$store.dispatch("storeCurrentProduct", response.data);
            this.$router.push('/dashboard/products')
          })
            .catch((error) => {
            console.log(error);
            this.loading = false;
          })
            .finally(() => {
            this.offerLoading = false
        });
      },
      priceChangeInPercentage() {
        this.changed = true;
        const initialPrice = this.initialPrice === null ? 0 : this.initialPrice;
        const actualPrice = this.actualPrice === null ? 0 : parseFloat(parseFloatFromGermanFloat(this.actualPrice));
        var decreaseValue = initialPrice - actualPrice;
        this.pricePercentage = (decreaseValue / initialPrice) * 100;
        this.pricePercentage = (this.pricePercentage * (-1));
        this.pricePercentage = this.round(this.pricePercentage);
      },
      round(value) {
        var multiplier = Math.pow(10, 1 || 0);
        return Math.round(value * multiplier) / multiplier;
      },
      getAllPrices() {
        this.axios.get("api/extra-charge/restricted")
        .then((response) => {
          this.prices = response.data;
          if(this.getChargeId !== 0) {
            let selectPrice = this.prices.find(x => x.id === this.getChargeId);
            this.extraCharge = selectPrice;
          }else {
            if(this.getProductId === 0) {
              let selectDefaultPrice = this.prices.find(x => x.isDefault === true);
              if(selectDefaultPrice != null) {
                this.setChargeId(selectDefaultPrice.id);
                this.extraCharge = selectDefaultPrice;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
      },
      saveCustomer(){
        const valid = this.$refs.addCustomerForm.validate();

        if (valid){
          const data = {
                "companydata": [
                  {
                    "company": this.customerFormProperties.isCompany ? "X" : "",
                    "title": this.customerFormProperties.title,
                    "title_1": "",
                    "name": this.customerFormProperties.name,
                    "name_2": this.customerFormProperties.isCompany ? "" : this.customerFormProperties.lastName,
                    "name_3": "",
                    "name_4": "",
                    "city": this.customerFormProperties.city,
                    "postCode": this.customerFormProperties.postCode,
                    "street": this.customerFormProperties.street,
                    "house_no": this.customerFormProperties.houseNo,
                    "country": this.customerFormProperties.country,
                    "tell_numbr": this.customerFormProperties.tellNumbr,
                    "e_mail": this.customerFormProperties.eMail,
                    "language": this.customerFormProperties.language,
                    "currency": "EUR"
                  }
                ]
              }

          this.addCustomerLoading = true
          this.axios.post('api/sap/addDebitor', data)
              .then(res => {
                const custmerNo = res.data[0].customerno

                const customer = {
                  active: false,
                  address: this.customerFormProperties.street + ' ' + this.customerFormProperties.houseNo,
                  anred: this.customerFormProperties.title,
                  canEditPrice: false,
                  city: this.customerFormProperties.city,
                  companyNumber: custmerNo,
                  companyType: '',
                  countryCode: this.customerFormProperties.country,
                  deliveryInformation: '',
                  id: 0,
                  isPersistent: false,
                  isWertheim: false,
                  locked: false,
                  name1: this.customerFormProperties.name,
                  name2: '',
                  name3: '',
                  parent: '',
                  postalCode: this.customerFormProperties.postCode,
                  profile: ''
                }

                this.addCustomer(customer)
                this.customer = this.getCustomers[this.getCustomers.length - 1]
                this.$refs.addCustomerForm.reset()
              })
              .catch(e => {
                this.snackbar.message = e.response.data.message;
                this.snackbar.show = true;
              } )
              .finally(() => {
                this.addCustomerLoading = false
                this.showCustomerDialog = false
              })
        }
      },
      selectCustomer(){
        const valid = this.$refs.selectCustomerForm.validate();

        if (valid){
          this.selectCustomerLoading = true
          this.axios.get(`api/sap/checkDebitorExists?companyNumber=${this.customerNo}`)
              .then(res => {
                const data = res.data

                const customer = {
                  active: false,
                  address: data.street,
                  anred: data.title,
                  canEditPrice: false,
                  city: data.city,
                  companyNumber: this.customerNo,
                  companyType: '',
                  countryCode: data.country,
                  deliveryInformation: '',
                  id: 0,
                  isPersistent: false,
                  isWertheim: false,
                  locked: false,
                  name1: data['name 1'],
                  name2: data['name 2'],
                  name3: data['name 3'],
                  parent: '',
                  postalCode: data.postalCode,
                  profile: ''
                }

                const existsCustomer = this.getCustomers.find(f => f.companyNumber === this.customerNo)
                if (existsCustomer){
                  this.customer = existsCustomer
                }else {
                  this.addCustomer(customer)
                  this.customer = this.getCustomers[this.getCustomers.length - 1]
                }
                this.showCustomerDialog = false
                this.$refs.selectCustomerForm.reset()
                this.selectCustomerHasError = false
              })
              .catch(e => {
                console.log(e.response)
                this.selectCustomerHasError = true
              })
              .finally(() => this.selectCustomerLoading = false)
        }
      },
      removePrice() {
        this.setChargeId(0);
        this.extraCharge = null;
      },
      calculatePrice(items){
        return items.reduce((a, b) => {
          return a + (parseFloat(b.price.replace(',', '.')) * b.quantity)
        }, 0).toFixed(2)
      },
      clearDate() {
        this.selectedDate = "";
      },
      closeOfferDialogEventHandler(){
        this.showOfferDialog = false
        this.clearDate()
      },
      closeCustomerDialogEventHandler(){
        this.showCustomerDialog = false
        this.$refs.addCustomerForm.reset()
      },
      closeSelectCustomerDialogEventHandler(){
        this.showCustomerDialog = false
        this.$refs.selectCustomerForm.reset()
        this.selectCustomerHasError = false
      },
      addCustomCustomer(){
        if (!this.getCustomer){
          const user = this.$store.state.user;
          this.axios.get(`api/company/getbyid`, {
            params: {
              id: user.companyId
            }
          })
              .then(res => {
                this.$store.dispatch('furtherInformationModule/setCustomer', res.data)
              })
        }
      },
      fetchAllLanguages(){
        this.axios.get('api/translate/fetchLanguages')
            .then(res => {
              this.languages = res.data
            })
      },
      customFilter (item, queryText, itemText) {
        const textOne = item.name1 ? item.name1.toLowerCase() : ''
        const textTwo = item.companyNumber ? item.companyNumber.toLowerCase() : ''
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
            textTwo.indexOf(searchText) > -1
      },
    },
    mounted() {
      var data = this.$store.state.currentProduct;
      var isEmpty = Object.keys(data).length === 0 && data.constructor === Object;
      if (!isEmpty) {
        if (
          this.$store.state.currentProduct.status == StatusTypes.ReadyForOrder
        ) {
          this.readyForOrder = true;
        } else {
          this.readyForOrder = false;
        }

        if (this.$store.state.currentProduct.price != 0) {
          if(this.$store.state.currentProduct.changedPrice != null)
          {
            this.actualPrice = parseToGermanFloat(this.$store.state.currentProduct.changedPrice);
            this.initialPrice = this.$store.state.currentProduct.price;
            // this.price = this.$store.state.currentProduct.changedPrice;
            this.price = this.$store.state.currentProduct.price;
            this.changed = true;
          }else {
            this.actualPrice = parseToGermanFloat(this.$store.state.currentProduct.price)
            this.initialPrice = this.$store.state.currentProduct.price
            this.price = this.$store.state.currentProduct.price;
            this.changed = false;
          }

            this.calculatedPrice = this.price
            if (this.$store.state.currentProduct.extraChargeValue){
                const calculatedPercentage = (parseFloat(this.$store.state.currentProduct.extraChargeValue) * this.price) / 100
                this.calculatedPrice += calculatedPercentage
            }
            // this.showGetPriceButton = false;
            this.showTotalPrice = true;

            if (this.$store.state.currentProduct.priceDetails !== "" && this.$store.state.currentProduct.priceDetails !== null){
                let priceDetails = JSON.parse(this.$store.state.currentProduct.priceDetails);
                priceDetails = [...priceDetails].map(m => {
                    return Object.keys(m).reduce((c, k) => (c[k.charAt(0).toLowerCase() + k.slice(1)] = m[k], c), {});
                })

                this.priceListDetails = priceDetails

                const myAccessories = JSON.parse(this.$store.state.currentProduct.myAccessories);
                if (myAccessories.length > 0){
                    //calculate price of additional accessories
                    const accessoriesPrice = this.calculatePrice(myAccessories)
                    //add additional accessories price to calculated price
                    this.calculatedPrice += parseFloat(accessoriesPrice)
                    //add additional accessories price to price list details
                    this.priceListDetails.push({description: 'Mein Zubehör', label: "myAccessoriesLabel", netValue: accessoriesPrice, currency: 'EUR'})
                }
                //parse to german culture with 2 decimals
                this.calculatedPrice = parseToGermanFloat(this.calculatedPrice.toFixed(2))
            }
        }
      }

      const userType = parseInt(this.$store.state.user.userType);

      this.canReadyForOrder = userType === UserTypes.SalesPartnershipProductConfigurator || userType === UserTypes.AffiliatePartnershipSales;
      this.canAddCustomer = userType === UserTypes.WertheimAdministrator || userType === UserTypes.WertheimSales

      if (
        userType === UserTypes.WertheimAdministrator ||
        userType === UserTypes.WertheimSales ||
        userType === UserTypes.SalesPartnershipAdmin ||
        userType === UserTypes.SalesPartnershipSales
      ) {
        this.canGetPriceAndOrderOffer = true;
      }

      this.canEditPriceRequest();
      this.getAllPrices();
      this.getAllCustomers()

      this.fetchAllLanguages()
      //If user is not WertheimAdmin and WertheimSales customer should be added automatically
      if (!this.canAddCustomer)
        this.addCustomCustomer()

    },
  };
</script>
<style scoped>
.percentage-calculation{
    white-space: nowrap;
}
</style>